import { render, staticRenderFns } from "./simple-close.vue?vue&type=template&id=757da40d"
import script from "./simple-close.vue?vue&type=script&lang=js"
export * from "./simple-close.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports